"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECOMMENDER_ANSWER_OPTIONS_LEADING_TO_NO_PRODUCTS = exports.DATA_RETENTION_PERIOD_DEFAULT = void 0;
const DATA_RETENTION_PERIOD_DEFAULT = exports.DATA_RETENTION_PERIOD_DEFAULT = 28;
const RECOMMENDER_ANSWER_OPTIONS_LEADING_TO_NO_PRODUCTS = exports.RECOMMENDER_ANSWER_OPTIONS_LEADING_TO_NO_PRODUCTS = {
  visible: 'visible',
  hidden: 'hidden',
  disabled: 'disabled'
};

// describes the JSONB column "custom_config" of the table "facebook_pages"